export default "__VITE_ASSET__ClPXlIv$__"